export default __webpack_public_path__ + "static/media/live-icon-active.9bdb7e32.webp";